import React, { useEffect, useState } from 'react'
import { Picker, Space, Popup, IndexBar, List, Input } from 'antd-mobile'
import { DownOutline, DownFill, CloseOutline } from 'antd-mobile-icons'

import styles from './index.scss'
import { getTelAreaCodes } from '@/services'
import { MobileAreaItem, MobileMapsTypes } from '@/interface'

export interface CountryCallPickerProps {
  value?: string
  onChange?: (value?: CountryCallPickerProps['value']) => void
  readOnly?: boolean
}

const CountryCallPicker: React.FC<CountryCallPickerProps> = ({
  value = '+86',
  onChange,
  readOnly = false,
}) => {
  const [visible, setVisible] = useState(false)
  const [commonAreaCodes, setCommonAreaCodes] = useState<MobileAreaItem[]>([])
  const [areaMaps, setAreaMaps] = useState<MobileMapsTypes>({})
  useEffect(() => {
    getTelAreaCodes().then((res) => {
      const { commonAreaCodes, areaCodes } = res
      const maps: MobileMapsTypes = {}

      ;(areaCodes || []).forEach((area: MobileAreaItem) => {
        const { firstWord } = area
        if (!maps[firstWord]) {
          maps[firstWord] = {
            name: firstWord,
            items: [],
          }
        }
        maps[firstWord].items.push(area)
      })
      setAreaMaps(maps)
      setCommonAreaCodes(commonAreaCodes)
    })
  }, [])

  return (
    <>
      <span
        onClick={() => {
          if (readOnly) return
          setVisible(true)
        }}
        style={{ verticalAlign: 'center' }}
      >
        <Space justify="center">
          <div>
            {value || '+86'}
            {/* {currentOption?.label || ''}
            {currentOption?.value || ''} */}
          </div>
          <DownFill
            style={{
              fontSize: 12,
              lineHeight: 1,
              display: 'inline-block',
              verticalAlign: 'baseline',
            }}
          />
          {/* <DownOutline style={{ color: `#ccc` }} /> */}
        </Space>
      </span>

      <Popup
        visible={visible}
        onMaskClick={() => {
          setVisible(false)
        }}
        className={styles.telAreaPopup}
        bodyStyle={{
          backgroundColor: 'transparent',
          // height: '80%',
        }}
      >
        <div className={styles.header}>
          电话区号{' '}
          <CloseOutline
            onClick={() => setVisible(false)}
            fontSize={14}
            className={styles.closeIcon}
          />
        </div>
        <div className={styles.container}>
          {commonAreaCodes.length > 0 && (
            <div className={styles.commonTels}>
              <h2 className={styles.title}>常用区号</h2>
              <section className={styles.tabList}>
                {(commonAreaCodes || []).map((area) => {
                  return (
                    <p key={area.code} className={styles.tabWrap}>
                      <span
                        onClick={() => {
                          // onPreValueChange(area)
                          onChange?.(area.number)
                          setVisible(false)
                        }}
                        className={`${styles.tab} ${
                          value === area.number ? styles.active : ''
                        }`}
                      >
                        {area.name} {area.number}
                      </span>
                    </p>
                  )
                })}
              </section>
            </div>
          )}
          <div className={styles.telAreaCodesWrap}>
            <div style={{ height: '60vh' }}>
              <IndexBar>
                {Object.keys(areaMaps).map((word: string) => {
                  const { name: title, items } = areaMaps[word]
                  return (
                    <IndexBar.Panel
                      index={title}
                      title={`${title}`}
                      key={`${title}`}
                    >
                      <List>
                        {items.map((item) => (
                          <List.Item
                            arrow={false}
                            onClick={() => {
                              // onPreValueChange(item)
                              onChange?.(item.number)
                              setVisible(false)
                            }}
                            key={item.code}
                          >
                            <span
                              className={`${styles.telCodeName} ${
                                value === item.number
                                  ? styles.telCodeNameActive
                                  : ''
                              }`}
                            >
                              {item.name} {item.number}
                            </span>
                          </List.Item>
                        ))}
                      </List>
                    </IndexBar.Panel>
                  )
                })}
              </IndexBar>
            </div>
          </div>
        </div>
      </Popup>

      {/* <Popup
        visible={visible}
        onMaskClick={() => {
          setVisible(false)
        }}
        showCloseButton
        bodyStyle={{
          borderTopLeftRadius: '8px',
          borderTopRightRadius: '8px',
        }}
        onClose={() => setVisible(false)}
      >
        <div className={styles.container}>
          <h3 className={styles.title}>区域码</h3>
          {options?.map((item) => (
            <div
              className={styles['label-item']}
              onClick={() => {
                onChange?.(item.value)
                setVisible(false)
              }}
            >
              <span>{item.label}</span>
              <span className={styles['label-item-right']}>{item.value}</span>
            </div>
          ))}
        </div>
      </Popup> */}
      {/* <Picker
        style={{
          '--title-font-size': '13px',
          '--header-button-font-size': '13px',
          '--item-font-size': '13px',
          '--item-height': '30px',
        }}
        className={styles['country-call-picker']}
        // defaultValue={['+86']}
        title="区域码"
        value={value ? [value] : undefined}
        columns={[options]}
        visible={visible}
        renderLabel={(item) => (
          <div className={styles['label-item']}>
            <span>{item.label}</span>
            <span className={styles['label-item-right']}>{item.value}</span>
          </div>
        )}
        onClose={() => {
          setVisible(false)
        }}
        onConfirm={(value) => {
          onChange?.(value?.[0])
        }}
      /> */}
    </>
  )
}

export default CountryCallPicker
